import { Component } from '@angular/core';
import { IonicPage, NavController, LoadingController } from 'ionic-angular';
import { Auth } from '../../providers/auth/auth';
import { ModalController } from 'ionic-angular';
import * as AppActions from '../../actions/app.actions';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'
import { Title } from '@angular/platform-browser';

@IonicPage({
  priority: 'high'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  email: string;
  password: string;
  loading: any;
  error;

  constructor(
    public store: Store<fromRoot.State>
    , public modalCtrl: ModalController
    , public navCtrl: NavController
    , public authService: Auth
    , public loadingCtrl: LoadingController
    , public title: Title
  ) {
    this.title.setTitle(`Willis Welby`);
  }

  ionViewDidEnter() {
    this.store.dispatch(new AppActions.SetPage('login'));

    this.showLoader();

    //Check if already authenticated
    this.authService.checkAuthentication().then((res) => {
      this.loading.dismiss();
      this.navCtrl.setRoot('HomePage');
    }, (err) => {
      this.loading.dismiss();
    });

  }

  login() {
    this.error = null;
    this.showLoader();
    let credentials = {
      email: this.email,
      password: this.password
    };

    this.authService.login(credentials).subscribe((result) => {
      this.loading.dismiss();
      this.navCtrl.setRoot('HomePage');
    }, (err) => {
      this.error = "problem contacting login service, try again later";
      this.loading.dismiss();
      console.error(err);
    })

  }

  showLoader() {

    this.loading = this.loadingCtrl.create({
      content: 'Authenticating...'
    });

    this.loading.present();

  }

  presentForgotPasswordPage() {
    let modal = this.modalCtrl.create('ForgotPasswordPage');
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts